import React, { Component } from "react";
import styles from "./emergencypatient.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class EmergencyPatients extends Component {
  state = {
    emergencyAppointmentOverview: "",
  };

  componentDidMount() {
    let emergencyappointments = JSON.parse(
      localStorage.getItem("emergency-appointment")
    );
    this.setState({
      emergencyAppointmentOverview: emergencyappointments
        ? emergencyappointments.data
        : [],
    });
  }
  handleRemove = (id) => {
    let filteredEmergencyAppointments = this.state.emergencyAppointmentOverview.filter(
      (emergencyappointment) => emergencyappointment.id !== id
    );
    console.log(this.state.emergencyAppointmentOverview);
    this.setState(
      { emergencyAppointmentOverview: filteredEmergencyAppointments },
      () => {
        localStorage.setItem(
          "emergency-appointment",
          JSON.stringify({ data: this.state.emergencyAppointmentOverview })
        );
      }
    );
  };

  scheduleAppoitment = () => {
    toast.info("Appointment scheduled...!", {
      autoClose: 2000,
    });
  };

  render() {
    return (
      <div className={styles.backgroundappoint}>
        <Header name="Emergency Appointments" />
        <Backicon
          onClick={() => this.props.history.goBack()}
          style={{
            background:
              "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
            color: "white",
          }}
        />
        <div className={basestyles.inputWidth}>
          <div className={styles.allapt}>
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Problem</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.state.emergencyAppointmentOverview &&
                  this.state.emergencyAppointmentOverview.map(
                    (emergencyappointment) => (
                      <tr key={emergencyappointment.id}>
                        <td>{emergencyappointment.id}</td>
                        <td>{emergencyappointment.Name}</td>
                        <td>
                          {emergencyappointment.TypeOfProblemHeSheIsFacing}
                        </td>
                        <td className={styles.acceptTrash}>
                          <i
                            className={"far fa-check-square"}
                            onClick={() => this.scheduleAppoitment()}
                          >
                            <ToastContainer />
                          </i>
                          <i
                            className={"fas fa-trash"}
                            onClick={() =>
                              this.handleRemove(emergencyappointment.id)
                            }
                          ></i>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default EmergencyPatients;
